import React from 'react';
import './App.css'; // Example CSS for modal styling
import closeIcon from './icons/close (1).png';

const Modal = ({ onClose, children }) => {
    return (
        <div className="modal-overlay-preview">
            <div className="modal-preview">
                <div className='button-c'>
                <div className="modal-close-preview" onClick={onClose}> <img className="Close-image-preview" src={closeIcon} alt="Close" /></div>
            </div>
                <div className="modal-content-preview">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;
